import * as React from "react"
import { Box } from "@mui/material"
import { DatePickerSeeker, disabledAfter } from "@ui-seeker/core"

import { YESTERDAY_DATE } from "@constants/date"
import {retailersTrackedDate} from "../../../@signals";

export default function RetailersTrackedTableToolbar() {
	return <Box sx={{ width: 185 }}>
		<DatePickerSeeker
			label="Filter by date"
			value={retailersTrackedDate.value}
			onChange={date => retailersTrackedDate.value = date}
			shouldDisableDate={disabledAfter(YESTERDAY_DATE)}
		/>
	</Box>
}
